import React, {useEffect, useState} from "react";
import BlogC from "../components/BlogC";
import { Link } from "react-router-dom";
import axios from "axios";
const Blog = () => {
    const [popularBlogs, setPopularBlogs] = useState([]);
    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_BLOG;
        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => setPopularBlogs(response.data))
            .catch(error => console.error("Error fetching API", error));
    }, []);

    return (
        <main>
            <section className="blog-banner-area" id="blog">
                <div className="container h-100">
                    <div className="blog-banner">
                        <div className="text-center">
                            <h1>Our Blogs</h1>
                            <nav aria-label="breadcrumb" className="banner-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">

                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Blog</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>

            <section className="blog_area pt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="blog_left_sidebar">

                                <BlogC />


                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="blog_right_sidebar">
                                <aside className="single_sidebar_widget popular_post_widget">
                                    <h3 className="widget_title">Popular Posts</h3>
                                    {popularBlogs.map((blg, index) => {
                                        return (
                                            <div className="media post_item" key={index}>
                                                <img className={"w-25"} src={blg.image} alt={blg.title} />
                                                <div className="media-body">
                                                    <Link className={'nav-link'} to={`/blog/${blg.slug}`}>{blg.title}</Link>
                                                </div>
                                            </div>
                                        );
                                    })}

                                    <div className="br"></div>
                                </aside>
                                <aside className="single_sidebar_widget ads_widget">
                                    <a href="#">
                                        <img className="img-fluid my-2" src="img/home/explore4.png" alt="" />
                                        <img className="img-fluid" src="img/home/explore5.png" alt="" />
                                    </a>
                                    <div className="br"></div>
                                </aside>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}
export default Blog;